export const ORDER_TABS = [
    { id: 'orders', title: 'Заказы' },
    { id: 'in_route', title: 'Заказы в маршрутах' },
    { id: 'not_in_route', title: 'Заказы вне маршрутов' },
    { id: 'favorites', title: 'Избранное' },
    { id: 'printed', title: 'Распечатан' },
    { id: 'staff', title: 'STAFF-заказы' },
]

// Индексы вкладок
export const TAB_INDEX = {
    ORDERS: 0,
    IN_ROUTE: 1,
    NOT_IN_ROUTE: 2,
    FAVORITES: 3,
    PRINTED: 4,
    STAFF: 5,
}
